import { render, staticRenderFns } from "./barChart2.vue?vue&type=template&id=ef45a526&scoped=true&"
import script from "./barChart2.vue?vue&type=script&lang=js&"
export * from "./barChart2.vue?vue&type=script&lang=js&"
import style0 from "./barChart2.vue?vue&type=style&index=0&id=ef45a526&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef45a526",
  null
  
)

export default component.exports